import { setSelectedVoicemails } from "@actions/itemSelectionActions";
import { makeItemSelector } from "./creators/makeSelector.hook";

const useVoicemailSelector = makeItemSelector(
  (state) => state.itemSelection.selectedVoicemails,
  setSelectedVoicemails
);

export default useVoicemailSelector;
